import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CrmSearchComponent } from './crm-search.component';

const routes: Routes = [{ path: '', component: CrmSearchComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CrmSearchRoutingModule { }
